// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__I2SgC","header":"Messages_header__29Mh-"};